var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10279",
    "data-name": "Group 10279",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.663,
    height: 22.461,
    viewBox: "0 0 23.663 22.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27600",
    "data-name": "Path 27600",
    d: "M1.809,9.413H21.855v11.24H1.809Zm16.33-4.384V3.419h3.715V7.6H1.809V3.419H5.638V5.028H7.445V3.419h8.886V5.028ZM16.331,0V1.611H7.445V0H5.638V1.611H0v20.85H23.663V1.611H18.139V0Z",
    fill: "#231f20"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2336",
    "data-name": "Rectangle 2336",
    width: 1.789,
    height: 1.808,
    transform: "translate(9.522 10.707)",
    fill: "#231f20"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2337",
    "data-name": "Rectangle 2337",
    width: 1.789,
    height: 1.808,
    transform: "translate(6.465 14.121)",
    fill: "#231f20"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2338",
    "data-name": "Rectangle 2338",
    width: 1.789,
    height: 1.808,
    transform: "translate(9.522 14.121)",
    fill: "#231f20"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2339",
    "data-name": "Rectangle 2339",
    width: 1.789,
    height: 1.808,
    transform: "translate(3.4 14.121)",
    fill: "#231f20"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2340",
    "data-name": "Rectangle 2340",
    width: 1.789,
    height: 1.808,
    transform: "translate(6.465 17.55)",
    fill: "#231f20"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2341",
    "data-name": "Rectangle 2341",
    width: 1.789,
    height: 1.808,
    transform: "translate(9.522 17.55)",
    fill: "#231f20"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2342",
    "data-name": "Rectangle 2342",
    width: 1.789,
    height: 1.808,
    transform: "translate(3.4 17.55)",
    fill: "#231f20"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2343",
    "data-name": "Rectangle 2343",
    width: 1.789,
    height: 1.808,
    transform: "translate(15.672 10.707)",
    fill: "#231f20"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2344",
    "data-name": "Rectangle 2344",
    width: 1.789,
    height: 1.808,
    transform: "translate(18.727 10.707)",
    fill: "#231f20"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2345",
    "data-name": "Rectangle 2345",
    width: 1.781,
    height: 1.808,
    transform: "translate(12.606 10.707)",
    fill: "#231f20"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2346",
    "data-name": "Rectangle 2346",
    width: 1.789,
    height: 1.808,
    transform: "translate(15.672 14.121)",
    fill: "#231f20"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2347",
    "data-name": "Rectangle 2347",
    width: 1.789,
    height: 1.808,
    transform: "translate(18.727 14.121)",
    fill: "#231f20"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2348",
    "data-name": "Rectangle 2348",
    width: 1.781,
    height: 1.808,
    transform: "translate(12.606 14.121)",
    fill: "#231f20"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2349",
    "data-name": "Rectangle 2349",
    width: 1.781,
    height: 1.808,
    transform: "translate(12.606 17.55)",
    fill: "#231f20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthIcon);
export default __webpack_public_path__ + "static/media/month_icon.af157018ac9f7da36ce5ed9d97361758.svg";
export { ForwardRef as ReactComponent };